import React, {useEffect, useState} from 'react';

import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import useStyles from './styles.js'
import {Link, Redirect} from 'react-router-dom';
import Logo from '../../assets/imgs/prospect_brasil.png'
import PeopleOutlinedIcon from '@material-ui/icons/PeopleOutlined';
import { useLocation } from 'react-router-dom';
import ExitToAppIcon    from '@material-ui/icons/ExitToApp';
import api from "../../services/api";
import Container from '@material-ui/core/Container';
import { aplicarValidacao, pode, sair } from "../../services/acesso";

const ehPaginaPublica = (caminho) => {
  return caminho === "/"
    || caminho === "/login"
    || caminho === "/politica"
    || caminho.startsWith("/cadastro/")
    || caminho.startsWith("/redefinir-senha/");
};

const usePathname = () => {
  const location = useLocation();
  return location.pathname;
}

function SiderBar(props) {
  const { window } = props;
  const classes = useStyles();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const caminho = usePathname();
  const paginaPublica = ehPaginaPublica(caminho);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <Container>
      <div className={classes.toolbar} style={{textAlign:"center",paddingTop:"5px"}}>
        
        <img src={Logo} width={200} alt="Prospect Brasil"></img>
      </div>
     
      <Divider />
      <List key={props.acessoVersao || 0}>
        {props.paths.map((path) => {
          if (path.viewMenu === true && (!path.acao || pode(path.acao))) {
            return (
                  <Link key={path.to} to={path.to} style={{ textDecoration: 'inherit', color:"#000", }}>
                    <ListItem button>
                        <ListItemIcon>
                          {path.icon}
                        </ListItemIcon>
                        <span>{path.text}</span>
                    </ListItem>
                  </Link>
            )
          }
          return null;
        })}
      </List>
      <Divider />
    </Container>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  const [redirect,setRedirect] = useState(false)

  useEffect(() => {
    if (paginaPublica) return undefined;
    let ativo = true;
    api.get("validar-login")
      .then((resposta) => {
        if (!ativo) return;
        aplicarValidacao(resposta.data);
      })
      .catch(function () {
        if (!ativo) return;
        sair();
        setRedirect(true);
      });
    return () => {
      ativo = false;
    };
  }, [caminho, paginaPublica]);

  if(!paginaPublica && redirect) {
    return <Redirect
      to={{
          pathname: "/login",
      }}
    />
  }

  return (
  
     <>
      {!paginaPublica ?
        <div className={classes.root} style={{ display: "block", width: "100%" }}>
        <AppBar position="fixed" className={classes.appBar}>
        <CssBaseline />
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
            PAINEL ADMINISTRATIVO
          </Typography>
        </Toolbar>
      </AppBar>
      <nav className={classes.drawer} aria-label="mailbox folders">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
            <div className={classes.logout}>
              <Link to="/" onClick={sair} style={{ textDecoration: 'inherit'}}>
                <ExitToAppIcon/>
              </Link>
            </div>
          </Drawer>
        </Hidden>
        
      </nav>
      <main className={classes.content} id="container-principal" style={{ boxSizing: "border-box", minWidth: 0, paddingLeft: "50px" }}>
        <div className={classes.toolbar}  />
            {props.children}
      </main></div>
        : props.children
      }
      
    </>
  );
}



export default SiderBar;
